export default function parseDate(dateString: string | null | undefined): Date | null {
  const date = new Date(dateString || "");
  return date.getTime() ? date : null;
}
